import type { ReactNode } from 'react';
import { BrandMark } from '../shell/BrandMark';

/**
 * Centered frame of the public console screens (sign-in, second factor,
 * invitation; style guide 2.12 without the split picture: the console is an
 * internal tool and says nothing about the product).
 */
export function AuthCard({ children }: { readonly children: ReactNode }) {
  return (
    <main id="main" className="ui-auth" tabIndex={-1}>
      <div className="ui-auth__card">
        <BrandMark />
        {children}
      </div>
    </main>
  );
}
